export default "__VITE_PUBLIC_ASSET__ea1305c2__"